import { createFileRoute } from "@tanstack/react-router";
import DePricing from "@/pages/DePricing";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/de/preise/")({
  head: () => routeHead("/de/preise/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <DePricing />
  );
}
